<template>
  <el-dialog
    :model-value="flagVisible" width="36%"
    :close-on-click-modal="false" :show-close="false" :close-on-press-escape="false"
  >
    <div class="modal-container">
      <div class="modal-title">
        <span>Hi {{ user.email }}!</span>
      </div>
      <div class="modal-text">
        <span>Let’s create your password and get you going with your ATK Player.</span>
      </div>
      <div class="modal-form">
        <el-form ref="form" :model="form" size="small">
          <div :class="['rule-password', errorPassword ? 'error' : '']">
            <span>8 characters or more, combining upper and lower-case letters, numbers, and special characters !@#$%^&*</span>
          </div>
          <div class="form-container">
            <el-input type="password" v-model="form.password" placeholder="Create Password" @change="checkPassword"></el-input>
            <el-input type="password" v-model="form.passwordConfirm" placeholder="Verify Password"></el-input>
          </div>
          <div class="form-confirm" @click="agreeTermsOfService = !agreeTermsOfService">
            <div :class="['ca-checkbox', agreeTermsOfService ? 'active': 'inactive']"></div>
            <span>I agree to the <a href="/terms" target="_blank">Terms & Conditions</a>.</span>
          </div>
          <div class="form-actions">
            <el-button class="el-btn-blue" :disabled="!agreeTermsOfService" @click="updatePassword">Create Account</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { reactive } from 'vue'
const md5 = require('md5')
export default {
  props: {
    flagVisible: Boolean,
    actionItem: Object
  },
  emits: ['handleComplete'],
  data: function () {
    const flagLoading = reactive({
      save: false
    })
    return {
      user: {},
      form: {
        password: '',
        passwordConfirm: ''
      },
      flagLoading,
      errorPassword: false,
      agreeTermsOfService: false
    }
  },
  created: function () {
  },
  watch: {
    actionItem: {
      handler: function (val, oldVal) {
        this.user = val
      },
      deep: true
    }
  },
  methods: {
    checkPassword: function (val) {
      const validReg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d!@#$%^&*]{8,}$/
      this.errorPassword = !validReg.test(val)
    },
    updatePassword: function () {
      const { password, passwordConfirm } = this.form
      this.checkPassword(password)
      if (this.errorPassword) {
        this.$message({ type: 'warning', message: 'Password should have 8 characters or more, combining upper and lower-case letters, numbers, and special characters !@#$%^&*' })
        return
      }
      if (password !== passwordConfirm) {
        this.$message({ type: 'warning', message: 'Password and confirm password must match' })
        return
      }
      this.flagLoading.save = true
      const url = '/api/v1/atk_player/users/update_password'
      const body = {
        origin_password: '',
        new_password: md5(password),
        password_confirm: md5(passwordConfirm)
      }
      const that = this
      this.$service.post(url, body).then(function (res) {
        if (res.code === 200) {
          that.$emit('handleComplete')
        } else {
          this.$message({ type: 'error', message: res.msg })
          that.flagLoading.save = false
        }
      }).catch(function (err) {
        console.error('updatePassword', err)
        that.$message({ type: 'error', message: err.msg })
        that.flagLoading.save = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.modal-container {
  padding: 0 60px 30px;
  color: black;
  .modal-title {
    font-size: 22px;
    font-weight: bold;
  }
  .modal-text {
    font-size: 16px;
    margin-top: 20px;
  }
  .modal-form {
    margin-top: 38px;
    .rule-password {
      font-size: 13px;
      text-align: center;
      color: #BDBDBD;
      margin-bottom: 10px;
      &.error {
        color: #C12D1C;
      }
    }
    .el-input {
      margin-bottom: 20px;
    }
    .form-confirm {
      margin: 20px 0 50px;
      cursor: pointer;
      font-size: 16px;
      display: flex;
      align-items: center;
      .ca-checkbox {
        margin-right: 10px;
      }
    }
    .form-actions {
      margin-top: 18px;
      text-align: center;
    }
  }
}
</style>
